
export type PlanType = "review" | "market" | "report" | null;

export interface PricingTier {
  id: PlanType;
  name: string;
  price: number;
  originalPrice: number;
  discountPercentage: number;
  recommended?: boolean;
  features: string[];
  description: string;
  credits: number;
  isContactUs?: boolean;
  contactUrl?: string;
  hidePrice?: boolean;
}

export const pricingTiers: PricingTier[] = [
  {
    id: "review",
    name: 'Testimonial Package',
    price: 2250,
    originalPrice: 2250,
    credits: 2250,
    discountPercentage: 0,
    features: [
      '10 glycemic impact tests with 2-day experiment protocol focusing on glucose spike and satiety response (150 credits per result)',
      'Minimum 10 results included - add more results at $150 each',
      'Access to anonymized tester data – demographic info and key metabolic health indicators',
      '5 verified user testimonial videos backed by validated test data (750 credits total, 150 credits per video)',
      'Recruitment support of up to 30 testers',
    ],
    description: "For product reviewers"
  },
  {
    id: "market",
    name: 'Influencer Package',
    price: 2900,
    originalPrice: 2900,
    credits: 2900,
    discountPercentage: 0,
    recommended: true,
    features: [
      'Everything included in Testimonial Package (2250 credits)',
      '4 validated influencer video posts on social media (1400 credits total, 350 credits per video)'
    ],
    description: "Full feature access"
  },
  {
    id: "report",
    name: 'Consumer Evidence Report Package',
    price: 0, // Custom pricing
    originalPrice: 0,
    credits: 0,
    discountPercentage: 0,
    features: [
      'Extended supplement testing protocol (2+ days per participant)',
      'Comprehensive metabolic impact analysis beyond glucose (insulin, inflammation markers)',
      'Structured scientific report with validated results, peer-reviewed by independent researchers',
      'Custom supplement testing protocols tailored to your product claims',
    ],
    description: "Perfect for supplement testing with extended protocol",
    isContactUs: true,
    contactUrl: "https://calendly.com/kiwibird/call-with-brands",
    hidePrice: true
  }
];

export const getSelectedPlan = (planId: PlanType): PricingTier | undefined => {
  return pricingTiers.find(plan => plan.id === planId);
};
